export default function TermsConditions() {
  return (
    <div className="max-w-5xl mx-auto p-6 md:p-10 text-gray-700">
      <h1 className="text-3xl font-heading text-palmGreen mb-6">
        Terms & Conditions – Flyteo.in
      </h1>

      <p className="mb-4">
        Welcome to <strong>Flyteo.in</strong> (“Company”, “we”, “our”, or “us”).
        By accessing or using our website and services—including hotel bookings,
        rooms, villas, camping, and adventure activity reservations—you agree to
        comply with the following Terms & Conditions.
      </p>

      <p className="mb-6">
        If you do not agree, please do not use our services.
      </p>

      {/* 1 */}
      <h2 className="text-xl font-semibold mt-6 mb-2">
        1. Use of Our Website
      </h2>
      <p className="mb-2">By using Flyteo.in, you confirm that:</p>
      <ul className="list-disc ml-6 space-y-1">
        <li>You are at least 18 years old.</li>
        <li>You will use the website for lawful purposes only.</li>
        <li>All information you provide is accurate and complete.</li>
        <li>
          You will not attempt to disrupt website performance or security.
        </li>
      </ul>

      {/* 2 */}
      <h2 className="text-xl font-semibold mt-6 mb-2">
        2. Booking Policy
      </h2>

      <h3 className="font-semibold mt-3 mb-1">2.1 General Bookings</h3>
      <p className="mb-2">
        All bookings made through Flyteo.in are subject to:
      </p>
      <ul className="list-disc ml-6 space-y-1">
        <li>Availability</li>
        <li>Supplier confirmation (hotels, villas, camps, activity partners)</li>
        <li>Valid payment</li>
      </ul>

      <h3 className="font-semibold mt-3 mb-1">2.2 Accuracy of Information</h3>
      <p className="mb-2">You are responsible for reviewing:</p>
      <ul className="list-disc ml-6 space-y-1">
        <li>Dates</li>
        <li>Number of guests</li>
        <li>Property details</li>
        <li>Activity details</li>
      </ul>
      <p className="mt-2">
        Flyteo.in is not liable for errors entered by the user.
      </p>

      {/* 3 */}
      <h2 className="text-xl font-semibold mt-6 mb-2">
        3. Payment Terms
      </h2>
      <ul className="list-disc ml-6 space-y-1">
        <li>
          All bookings require full or partial payment depending on the provider.
        </li>
        <li>
          Payments are processed via secure third-party payment gateways.
        </li>
        <li>
          Flyteo.in does not store your complete card details.
        </li>
      </ul>

      <div className="bg-sand p-4 rounded mt-4">
        <p className="font-semibold mb-1">Important Notes:</p>
        <ul className="list-disc ml-6 space-y-1">
          <li>
            Refund processing time: 10–20 business days depending on the payment
            provider.
          </li>
          <li>
            GST, convenience fees, and service charges are non-refundable.
          </li>
        </ul>
      </div>

      {/* 5 */}
      <h2 className="text-xl font-semibold mt-6 mb-2">
        5. Pricing & Availability
      </h2>
      <ul className="list-disc ml-6 space-y-1">
        <li>
          Prices may change based on availability or partner updates.
        </li>
        <li>
          Flyteo.in reserves the right to modify or cancel bookings with prior
          notice in case of pricing errors or unavailability.
        </li>
      </ul>

      {/* 6 */}
      <h2 className="text-xl font-semibold mt-6 mb-2">
        6. User Responsibilities
      </h2>
      <p className="mb-2">You must:</p>
      <ul className="list-disc ml-6 space-y-1">
        <li>Provide accurate personal and booking details.</li>
        <li>Follow hotel, camp, and activity partner rules.</li>
        <li>Carry valid government ID for check-ins.</li>
        <li>Ensure your safety during adventure activities.</li>
      </ul>
      <p className="mt-2">
        Flyteo.in is not responsible for losses caused by negligence,
        misconduct, or failure to follow guidelines.
      </p>

      {/* 7 */}
      <h2 className="text-xl font-semibold mt-6 mb-2">
        7. Liability Disclaimer
      </h2>
      <p className="mb-2">
        Flyteo.in is an aggregator platform. We are not responsible for:
      </p>
      <ul className="list-disc ml-6 space-y-1">
        <li>
          Damages caused by hotels, villas, camps, or activity partners
        </li>
        <li>
          Accidents, injuries, or losses during travel or activities
        </li>
        <li>
          Delays due to weather, natural calamities, strikes, or government
          restrictions
        </li>
      </ul>
      <p className="mt-2">
        Our liability is limited to the booking amount paid to us.
      </p>

      {/* 8 */}
      <h2 className="text-xl font-semibold mt-6 mb-2">
        8. Fraud Prevention
      </h2>
      <ul className="list-disc ml-6 space-y-1">
        <li>Cancel suspicious bookings</li>
        <li>Request additional verification documents</li>
        <li>Deny service for fraudulent or abusive behavior</li>
      </ul>

      {/* 9 */}
      <h2 className="text-xl font-semibold mt-6 mb-2">
        9. Intellectual Property
      </h2>
      <p>
        All content on Flyteo.in—including text, images, logos, and graphics—is
        the property of Flyteo.in. Unauthorized use or copying is strictly
        prohibited.
      </p>

      {/* 10 */}
      <h2 className="text-xl font-semibold mt-6 mb-2">
        10. Third-Party Links
      </h2>
      <p className="mb-2">
        Our website may contain links to third-party websites.
        Flyteo.in is not responsible for:
      </p>
      <ul className="list-disc ml-6 space-y-1">
        <li>Their content</li>
        <li>Their privacy practices</li>
        <li>Any damages arising from their use</li>
      </ul>

      {/* 11 */}
      <h2 className="text-xl font-semibold mt-6 mb-2">
        11. Privacy Policy
      </h2>
      <p>
        Use of our services is also governed by our Privacy Policy, available on
        the website.
      </p>

      {/* 12 */}
      <h2 className="text-xl font-semibold mt-6 mb-2">
        12. Modifications
      </h2>
      <p>
        Flyteo.in may update these Terms & Conditions at any time. The latest
        version will always be posted here with a new “28 dec 2025” date.
      </p>

      {/* 13 */}
      <h2 className="text-xl font-semibold mt-6 mb-2">
        13. Contact Us
      </h2>
      <p className="mt-2">
        <strong>Flyteo.in – Support Team</strong>
      </p>
      <p>📧 Email: flyteotravels@gmail.com</p>
      <p>📞 Phone: 8975995125</p>
    </div>
  );
}
